export class HhgUabCalculator{
    uabType : any;
    uabWeight : number;
    uabPct : number;
    height : number;
    width : number;
    length : number;
    totalChgKg : number;
}

export class UabCostInfo{
    grossKgR : number;
    grossKg : number;
    chargeKg : number;
    billKg : number;
    perKg : number;
    billToGovt :any;
}